var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('header',{staticClass:"main-header"},[_c('h1',[_vm._v(" Trending ")]),_c('pagination',{attrs:{"current":_vm.currentPage},on:{"change":_vm.changePage}})],1),_c('songs-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }